import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Avatar,
  useTheme,
  Skeleton
} from '@mui/material';
import BalanceIcon from '@mui/icons-material/Balance';

import { IcmsPorPerdas } from './types';

type TableIcmsPerdasProps = {
  data: IcmsPorPerdas[];
  loading?: boolean;
};

const formatCurrency = (value: number) =>
  value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

const TableIcmsPerdas: React.FC<TableIcmsPerdasProps> = ({ data, loading = false }) => {
  const theme = useTheme();

  return (
    <Card sx={{ p: 2 }}>
      <CardContent sx={{ p: 0 }}>
        <Box display="flex" alignItems="center" mb={2}>
          <Avatar
            sx={{
              bgcolor: theme.palette.error.light,
              color: theme.palette.error.main,
              width: 36,
              height: 36,
              mr: 1
            }}
          >
            <BalanceIcon />
          </Avatar>
          <Typography variant="subtitle1" sx={{ color: theme.palette.text.secondary }}>
            Detalhamento de Perdas por NFE
          </Typography>
        </Box>

        <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell><strong>Código</strong></TableCell>
                <TableCell><strong>Descrição Completa</strong></TableCell>
                <TableCell align="right"><strong>Valor do Item</strong></TableCell>
                <TableCell align="right"><strong>Quantidade</strong></TableCell>
                <TableCell><strong>Unidade</strong></TableCell>
                <TableCell><strong>Data Emissão</strong></TableCell>
                <TableCell><strong>Número Documento</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                Array.from({ length: 5 }).map((_, index) => (
                  <TableRow
                    key={`skeleton-${index}`}
                    sx={{
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f5f5f5'
                    }}
                  >
                    <TableCell>
                      <Skeleton variant="text" width="80%" height={16} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width="90%" height={16} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width="70%" height={16} />
                    </TableCell>
                    <TableCell align="right">
                      <Skeleton variant="text" width="60%" height={16} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width="50%" height={16} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width="75%" height={16} />
                    </TableCell>
                    <TableCell>
                      <Skeleton variant="text" width="85%" height={16} />
                    </TableCell>
                  </TableRow>
                ))
              ) : data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    Nenhum dado encontrado.
                  </TableCell>
                </TableRow>
              ) : (
                data.map((item, index) => (
                  <TableRow
                    key={`${item.cod_item}-${index}`}
                    sx={{
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f5f5f5'
                    }}
                  >
                    <TableCell>{item.cod_item}</TableCell>
                    <TableCell>{item.descr_compl}</TableCell>
                    <TableCell align="right">{formatCurrency(item.vl_item)}</TableCell>
                    <TableCell align="right">{item.qtd}</TableCell>
                    <TableCell>{item.unid}</TableCell>
                    <TableCell>{item.dt_emissao}</TableCell>
                    <TableCell>{item.num_doc}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default TableIcmsPerdas;
